import { detect } from 'detect-browser';

import { operatingSystems } from './constants.util';

export const isMobile = (): boolean => isAndroid() || isAppleIOS();

export const isAndroid = (): boolean => detect()!.os === operatingSystems.Android;

export const isAppleIOS = (): boolean => detect()!.os === operatingSystems.AppleIOS;
